"use client";
import { jsxs as n, jsx as a } from "react/jsx-runtime";
const c = ({
  title: h,
  titleId: r,
  desc: i,
  descId: e,
  ...l
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": e,
    ...l,
    children: [
      h ? /* @__PURE__ */ a("title", { id: r, children: h }) : null,
      i === void 0 ? /* @__PURE__ */ a("desc", { id: e, children: `
    Briefcase Thin Streamline Icon: https://streamlinehq.com
  ` }) : i ? /* @__PURE__ */ a("desc", { id: e, children: i }) : null,
      /* @__PURE__ */ a("path", { d: "M6.03 6.912a.294.294 0 0 1 .294-.294h2.352c.2263 0 .3678.245.2546.441a.294.294 0 0 1-.2546.147H6.324a.294.294 0 0 1-.294-.294m8.82-2.94v9.408a.882.882 0 0 1-.882.882H1.032a.882.882 0 0 1-.882-.882V3.972a.882.882 0 0 1 .882-.882h3.234v-.882c0-.8119.6581-1.47 1.47-1.47h3.528c.8119 0 1.47.6581 1.47 1.47v.882h3.234a.882.882 0 0 1 .882.882M4.854 3.09h5.292v-.882a.882.882 0 0 0-.882-.882H5.736a.882.882 0 0 0-.882.882Zm-4.116.882v3.234A13.82 13.82 0 0 0 7.5 8.97a13.82 13.82 0 0 0 6.762-1.764V3.972a.294.294 0 0 0-.294-.294H1.032a.294.294 0 0 0-.294.294m13.524 9.408V7.8748A14.41 14.41 0 0 1 7.5 9.558 14.406 14.406 0 0 1 .738 7.8748V13.38a.294.294 0 0 0 .294.294h12.936a.294.294 0 0 0 .294-.294" })
    ]
  }
);
export {
  c as default
};
